import React, { ChangeEvent, FC, useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import * as S from './styled'
import { Text } from '../../../redesign'

const Container = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 560px;
    gap: 8px;
`

const formatTime = (time: number) => {
    if (time === 0) return '--:--'
    const minutes = Math.floor(time / 60)
    const seconds = Math.floor(time % 60)
    const returnedSeconds = seconds < 10 ? `0${seconds}` : seconds
    return `${minutes}:${returnedSeconds}`
}

interface Props {
    currentTime: number
    bufferedTime: number
    maxTime: number
    onChange: (value: number) => void
}

export const AudioProgressSlider: FC<Props> = ({
    currentTime,
    bufferedTime,
    maxTime,
    onChange,
}) => {
    const [currentTimeString, setCurrentTimeString] = useState('')
    const [maxTimeString, setMaxTimeString] = useState('--:--')
    const [sliderThumbDistance, setSliderThumbDistance] = useState('')
    const [bufferedDistance, setBufferedDistance] = useState('')

    useEffect(() => {
        setCurrentTimeString(formatTime(currentTime))
    }, [currentTime])

    useEffect(() => {
        setMaxTimeString(formatTime(maxTime))
    }, [maxTime])

    useEffect(() => {
        if (currentTime > 0 && maxTime > 0) {
            setSliderThumbDistance(`${(currentTime / maxTime) * 100}%`)
        }
    }, [currentTime, maxTime])

    useEffect(() => {
        if (bufferedTime > 0 && maxTime > 0) {
            setBufferedDistance(`${(bufferedTime / maxTime) * 100}%`)
        }
    }, [bufferedTime, maxTime])

    return (
        <Container>
            <Text size="xxxSmall" $weight="bold" color="secondary">
                {currentTimeString}
            </Text>

            <S.AudioProgressSlider
                value={currentTime}
                $bufferedWidth={bufferedDistance}
                $seekBeforeWidth={sliderThumbDistance}
                max={maxTime}
                onInput={(e: ChangeEvent<HTMLInputElement>) => {
                    onChange(e.target.valueAsNumber)
                }}
            />

            <Text size="xxxSmall" $weight="bold" color="secondary">
                {maxTimeString}
            </Text>
        </Container>
    )
}
